<template>
  <div class="status-guide">
    <div class="status-list">
      <CustomCheck
        label="Student Number"
        :model-value="aptFilterData.student_sis_id"
        @change="updateFilters"
        name="student_sis_id"
      />
    </div>
  </div>
</template>

<script>
import CustomCheck from "@/v3components/shared/Form/CustomCheck.vue"
import { computed } from "vue"
import { useStore } from "vuex"

export default {
  name: "DashboardTimeFiltersOld",
  components: {
    CustomCheck
  },
  setup() {
    const store = useStore()

    const aptFilterData = computed(
      () => store.getters["dashboardTable/aptFilterData"]
    )

    const updateFilters = (value) => {
      store.commit("dashboardTable/UPDATE_APT_FILTERS_DATA", {
        filter: "student_sis_id",
        value
      })
    }

    return {
      aptFilterData,
      updateFilters
    }
  }
}
</script>
